// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1njw-","editor":"style_editor__121tN","note":"style_note__jNZkF","words":"style_words__29M9m"};